
import { useQuotationVM } from "presentation/hook/QuotationSetting/useQuotationVM";
import { useQuotationTracked } from "presentation/store/QuotationSetting/QuotationProvider";
import { useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import QuotationEditPanel from "./QuotationEditPanel";
import QuotationTablePanel from "./QuotationTablePanel";

export const QuotationMaintenance: React.FC = () => {
    const [quotationState] = useQuotationTracked();
    const quotationVM = useQuotationVM();
    const { isShowEditPanel } = quotationState;
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const initialScreen = async () => {
            try {
                const results = await Promise.allSettled([
                    quotationVM.onSearch(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {
                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            setIsLoading(false);
        });

    }, [quotationVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper im-hide-side-form-draggable`}>
            {isShowEditPanel && <QuotationEditPanel />}
            {!isShowEditPanel && <SliderPanel
                isOpen={true}
                leftSectionWidth={'100%'}
                rightSectionWidth={"0%"}
                draggable={false}
                leftChildren={<QuotationTablePanel />}
            />}
        </div>
    </>
}